import { useState } from 'react'

import { Role } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { Link } from '@tribeplatform/react-ui-kit/Link'
import { Select } from '@tribeplatform/react-ui-kit/Select'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { useUserImportContext } from './UserImportContext'

export interface RoleSelectProps {
  options: Role[]
  onChange: (value: Role) => void
  value: Role
  onBlur
  name: string
}

export const RoleSelect: React.FC<RoleSelectProps> = ({
  options,
  onChange,
  value,
}) => {
  const context = useUserImportContext()

  const [customSelect, setCustomSelect] = useState(false)

  return (
    <>
      {customSelect && (
        <Select onChange={onChange} value={value}>
          <Select.Button placeholder="Select role">{value?.name}</Select.Button>
          <Select.Items>
            {options.map(role => (
              <Select.Item key={role.id} value={role}>
                {role.name}
              </Select.Item>
            ))}
          </Select.Items>
        </Select>
      )}
      {!customSelect && (
        <div className="text-sm flex space-s-2 text-content-subdued">
          {value && (
            <Text>
              <T
                defaultMessage="New {MEMBERS} will automatically become {role}"
                id="UserImport.AssignedRole"
                values={{
                  role: <b>{value.name}</b>,
                }}
              />
            </Text>
          )}
          {context?.hasInviteDefaultsPermission && (
            <Link
              as="button"
              type="button"
              onClick={() => setCustomSelect(true)}
              data-testid="role-edit"
            >
              <T defaultMessage="Edit" id="Generics.Edit" />
            </Link>
          )}
        </div>
      )}
    </>
  )
}
